// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogClose, DialogContent, DialogTitle, P, } from '@a-type/ui';
import { useContext, useEffect, useState } from 'react';
import { VerdantContext } from '../verdant.js';
export function ResetNotifier({}) {
    const [shown, setShown] = useState(false);
    const clientDesc = useContext(VerdantContext);
    useEffect(() => {
        if (!(clientDesc === null || clientDesc === void 0 ? void 0 : clientDesc.current))
            return;
        const client = clientDesc.current;
        return client.subscribe('resetToServer', () => {
            setShown(true);
        });
    }, [clientDesc]);
    const [waiting, setWaiting] = useState(false);
    useEffect(() => {
        if (shown) {
            setWaiting(true);
            const timeout = setTimeout(() => {
                setWaiting(false);
                setShown(false);
            }, 5000);
            return () => clearTimeout(timeout);
        }
    }, [shown]);
    return (_jsx(Dialog, { open: shown, onOpenChange: setShown, children: _jsxs(DialogContent, { children: [_jsx(DialogTitle, { children: "Catching up..." }), _jsx(P, { children: "It's been a while since you've used this app. Fetching the latest data from the server!" }), _jsx(DialogActions, { children: _jsx(DialogClose, { asChild: true, children: _jsx(Button, { loading: waiting, children: "Ok" }) }) })] }) }));
}
//# sourceMappingURL=ResetNotifier.js.map